
import { defineComponent } from "vue";
import { Scenes } from "../utils/scenes";
export default defineComponent({
  name: "LevelUpPopup",
  data: () => ({
    showModal: false,
    startLvl: true,
    loading: true,
    isStartEnable: false,
    level: Number(window.getLevel())
  }),
  methods: {
    startGame(){
      this.loading = true;
        const phaserGame = document.querySelector('.phaser-game');
        (phaserGame as HTMLDivElement).style.display = 'flex';
        this.startLvl = false
        window.showOrHideInstructionPopup1(false);
        window.showOrHideLevelUpPopup(false);
        window.startGame();
    },
    playGame(){
      this.level+=1;
      window.updateLevel();
      window.restartGame();
      window.showOrHideLevelUpPopup(false);
    },
    handleKeypress(event: KeyboardEvent) {
      if (event.code === 'Escape') {
        this.playGame()
      }
    },
    showPopup(show: boolean) {
      console.log('showpup '+this.level)
      this.showModal = show;
      if (show) {
        document.addEventListener('keydown', this.handleKeypress)
      } else {
        document.removeEventListener('keydown', this.handleKeypress)
      }
    }
  },
  mounted() {
    console.log('v-if="level == 1 && startLvl==false' );
    console.log(this.level + ' . ' + this.startLvl);
    window.showOrHideLevelUpPopup = this.showPopup;
  }
});
